export const THEME_STORAGE_KEY = "ho-kitchen-theme"

export type Theme = "dark" | "light" | "system"

type PublicEnv = {
  BUN_PUBLIC_API_URL?: string
  BUN_PUBLIC_SUPABASE_ANON_KEY?: string
  BUN_PUBLIC_SUPABASE_URL?: string
}

function publicEnv(): PublicEnv {
  const injected = (globalThis as { __HO_KITCHEN_ENV__?: PublicEnv }).__HO_KITCHEN_ENV__
  if (injected) return injected
  return {
    BUN_PUBLIC_API_URL: import.meta.env?.BUN_PUBLIC_API_URL,
    BUN_PUBLIC_SUPABASE_ANON_KEY: import.meta.env?.BUN_PUBLIC_SUPABASE_ANON_KEY,
    BUN_PUBLIC_SUPABASE_URL: import.meta.env?.BUN_PUBLIC_SUPABASE_URL,
  }
}

export function getApiBaseUrl(): string {
  return publicEnv().BUN_PUBLIC_API_URL || "http://localhost:3000"
}

export function getSupabaseUrl(): string {
  return publicEnv().BUN_PUBLIC_SUPABASE_URL || ""
}

export function getSupabaseAnonKey(): string {
  return publicEnv().BUN_PUBLIC_SUPABASE_ANON_KEY || ""
}

export function isSupabaseConfigured(): boolean {
  return Boolean(getSupabaseUrl() && getSupabaseAnonKey())
}
